import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { I18nService } from '@core/i18n/i18n.service';
import { LoadingService } from '@core/services/loading.service';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  matEventAvailable,
  matFlag,
  matHub,
  matLightbulb,
  matPeopleAlt,
} from '@ng-icons/material-icons/baseline';
import { TranslateModule } from '@ngx-translate/core';
import { InternalIconComponent } from '@shared/components/internal-icon/internal-icon.component';
import { SharedIconComponent } from '@shared/components/shared-icon/shared-icon.component';
import { ActiveRouteDirective } from '@shared/directives/active-route.directive';
import { LanguagePathDirective } from '@shared/directives/language-path.directive';
import { UnsavedFormCheckDirective } from '@shared/directives/unsaved-form-check.directive';
import { UrlParam } from '@shared/enums/url-param.enum';
import { WINDOW } from '@shared/helpers/window.token';
import { NavInterface } from '@shared/interfaces/nav.interface';
import { StringUtils } from '@shared/utils/string-utils';

@Component({
  selector: 'app-nav-item',
  templateUrl: './nav-item.component.html',
  imports: [
    CommonModule,
    NgIcon,
    ActiveRouteDirective,
    LanguagePathDirective,
    UnsavedFormCheckDirective,
    SharedIconComponent,
    InternalIconComponent,
    TranslateModule,
  ],
  viewProviders: [
    provideIcons({
      matFlag,
      matLightbulb,
      matPeopleAlt,
      matEventAvailable,
      matHub,
    }),
  ],
})
export class NavItemComponent {
  @Input() item: NavInterface;
  @Input() count = 0;
  @Input() wrapperClass = '';

  unsavedFormCheck: boolean;

  constructor(
    private readonly loading: LoadingService,
    private readonly i18nService: I18nService,
    @Inject(WINDOW) private readonly window: Window
  ) {}

  launchLoadingIndicator(event: Event, href: string): void {
    event.preventDefault();
    if (this.unsavedFormCheck) return;
    this.loading.setLoadingState(true);

    const locale = this.i18nService.language.locale.toLowerCase();
    href = StringUtils.propagateParamFromCurrentUrl(
      '/' + locale + href,
      UrlParam.FilterTokenId
    );

    setTimeout(() => {
      this.window.location.href = href;
    }, 0);
  }

  handleUnsavedFormState(val: boolean) {
    this.unsavedFormCheck = val;
  }
}
